import { isDevMode } from '@angular/core';
import { BE_URI_DEV, BE_URI_PROD } from '@ess/shared-utils';

// Single source for the API origin. Apollo talks to /graphql, but the admin CSV export is
// a plain authenticated GET on the same server; resolving the origin twice is how the two
// end up pointing at different environments.
export function apiOrigin(): string {
  return graphqlUri().replace(/\/graphql$/, '');
}

export function graphqlUri(): string {
  return isDevMode() ? BE_URI_DEV : BE_URI_PROD;
}
